var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    viewBox: "0 0 66 66",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D4EFFC;}\n\t.st1{fill:#A0DFFF;}\n\t.st2{fill:#364DEC;}\n\t.st3{fill:#FABF63;}\n\t.st4{fill:#F5B6A3;}\n\t.st5{fill:#26CD9D;}\n\t.st6{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 5.68,
    width: 2.49,
    x: 21.7,
    y: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 5.68,
    width: 2.49,
    x: 41.8,
    y: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 31.07,
    width: 1.85,
    x: 17.28,
    y: 10.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 31.07,
    width: 1.85,
    x: 46.87,
    y: 10.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 22.71,
    width: 1.71,
    x: 14.85,
    y: 41.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 22.71,
    width: 1.71,
    x: 49.44,
    y: 41.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.28,65c-0.4,0-0.73-0.33-0.73-0.73v-8.29c0-0.4,0.33-0.73,0.73-0.73c0.4,0,0.73,0.33,0.73,0.73v8.29      C60.01,64.67,59.69,65,59.28,65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.96,54.62c0,2.58-2.09,4.68-4.67,4.68c-2.58,0-4.68-2.09-4.68-4.68c0-2.58,2.09-7.76,4.68-7.76      C61.86,46.87,63.96,52.04,63.96,54.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.72,65c-0.4,0-0.73-0.33-0.73-0.73v-8.29c0-0.4,0.33-0.73,0.73-0.73c0.4,0,0.73,0.33,0.73,0.73v8.29      C7.44,64.67,7.12,65,6.72,65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.39,54.62c0,2.58-2.09,4.68-4.67,4.68c-2.58,0-4.68-2.09-4.68-4.68c0-2.58,2.09-7.76,4.68-7.76      C9.3,46.87,11.39,52.04,11.39,54.62z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.93,65H27.06c-0.4,0-0.73-0.33-0.73-0.73V46.66c0-0.4,0.33-0.73,0.73-0.73h11.87    c0.4,0,0.73,0.33,0.73,0.73v17.61C39.66,64.67,39.33,65,38.93,65z M27.79,63.54H38.2V47.38H27.79V63.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.06,65H1.94c-0.4,0-0.73-0.33-0.73-0.73s0.33-0.73,0.73-0.73h62.11c0.4,0,0.73,0.33,0.73,0.73    S64.46,65,64.06,65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.15,65H14.85c-0.4,0-0.73-0.33-0.73-0.73v-22.7c0-0.4,0.33-0.73,0.73-0.73h36.29    c0.4,0,0.73,0.33,0.73,0.73v22.7C51.87,64.67,51.55,65,51.15,65z M15.58,63.54h34.84V42.29H15.58V63.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.72,42.29H17.28c-0.4,0-0.73-0.33-0.73-0.73V10.5c0-0.4,0.33-0.73,0.73-0.73h31.44    c0.4,0,0.73,0.33,0.73,0.73v31.07C49.44,41.97,49.12,42.29,48.72,42.29z M18.01,40.84h29.98V11.23H18.01V40.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.16,11.23H13.83c-0.4,0-0.73-0.33-0.73-0.73s0.33-0.73,0.73-0.73h38.33c0.4,0,0.73,0.33,0.73,0.73    S52.57,11.23,52.16,11.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.34,42.29H12.66c-0.4,0-0.73-0.33-0.73-0.73s0.33-0.73,0.73-0.73h40.68c0.4,0,0.73,0.33,0.73,0.73    S53.74,42.29,53.34,42.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.05,11.23c-0.4,0-0.73-0.33-0.73-0.73V7.41c0-0.4,0.33-0.73,0.73-0.73S25.78,7,25.78,7.41v3.09     C25.78,10.9,25.45,11.23,25.05,11.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.95,11.23c-0.4,0-0.73-0.33-0.73-0.73V7.41c0-0.4,0.33-0.73,0.73-0.73S41.67,7,41.67,7.41v3.09     C41.67,10.9,41.35,11.23,40.95,11.23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.3,8.13H21.7c-0.4,0-0.73-0.33-0.73-0.73V1.73C20.97,1.33,21.3,1,21.7,1H44.3c0.4,0,0.73,0.33,0.73,0.73    v5.68C45.02,7.81,44.7,8.13,44.3,8.13z M22.43,6.68h21.14V2.46H22.43V6.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 20.24,
    y: 13.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 29.59,
    y: 13.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 38.93,
    y: 13.21
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 20.24,
    y: 22.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 29.59,
    y: 22.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 38.93,
    y: 22.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 20.24,
    y: 31.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 29.59,
    y: 31.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 6.97,
    width: 6.82,
    x: 38.93,
    y: 31.68
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.97,47.38H25.02c-0.4,0-0.73-0.33-0.73-0.73c0-0.4,0.33-0.73,0.73-0.73h15.95c0.4,0,0.73,0.33,0.73,0.73    C41.7,47.06,41.37,47.38,40.97,47.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 5.66,
    width: 6.58,
    x: 17.28,
    y: 48.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 5.66,
    width: 6.58,
    x: 17.28,
    y: 56.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 5.66,
    width: 6.58,
    x: 41.82,
    y: 48.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 5.66,
    width: 6.58,
    x: 41.82,
    y: 56.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.96,55.46c0,0.57-0.46,1.03-1.02,1.03c-0.56,0-1.02-0.46-1.02-1.03c0-0.56,0.46-1.02,1.02-1.02    C36.5,54.44,36.96,54.9,36.96,55.46z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.c74010897ee15b6c6c320cd55c705ea0.svg";
export { ForwardRef as ReactComponent };